import { useState, useEffect } from 'react';
import { db } from "../../firebase";
import { ref, child, get, remove } from "firebase/database";
import { MdDelete } from "react-icons/md";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Image from 'react-bootstrap/Image';

const AdminPost = () => {

    useEffect(() => {
        populateData();
    }, []);

    const dbRef = ref(db);

    async function populateData() {
        get(child(dbRef, `images`)).then((snapshot) => {
            if (snapshot.exists()) {
                let data = []
                snapshot.forEach(node => {
                    let caption = node.val().caption;
                    let src = node.val().src;
                    let id = node.val().id;
                    let width = 600;
                    let height = 400;
                    data = [...data, { caption, src, width, height, id }]
                })
                setImages([...imagesNew, ...data]);
            } else {
                console.log("No data available");
            }
        }).catch((error) => {
            console.error(error);
        });
    }

    async function deleteNode(id) {
        let path = `images/` + id;
        const dbRefToDelete = ref(db, path);
        try {
            const newArray = imagesNew.filter((item, index) => item.id != id);
            setImages(newArray);
            await remove(dbRefToDelete);
            console.log("Data deleted successfully!");
        } catch (error) {
            console.error("Error deleting data: ", error);
        }
    }

    const [imagesNew, setImages] = useState([]);

    return (
        <Container fluid >
            {/* Create rows with 3 images each */}
            {imagesNew.reduce((acc, data, index) => {
                if (index % 4 === 0) acc.push([]); // Start a new row every 3 items
                acc[acc.length - 1].push(data); // Add the current image to the last row
                return acc;
            }, []).map((rowData, rowIndex) => (
                <Row key={rowIndex} className="mb-3">
                    {rowData.map((data, colIndex) => (
                        <Col md={3} sm={6} key={colIndex}>
                            <Image
                                src={data.src}
                                alt={`Image ${colIndex}`}
                                style={{ width: '300px', height: '200px' }}
                                rounded
                                fluid />
                            <Container>
                                <Button
                                    variant="primary"
                                    onClick={() => deleteNode(data.id)}
                                    style={{ marginBottom: '10px', marginTop: '10px' }}>
                                    <MdDelete />
                                </Button>
                            </Container>
                        </Col>
                    ))}
                </Row>
            ))}
        </Container>
    );

}

export default AdminPost;